import { render, staticRenderFns } from "./releaseDtu.vue?vue&type=template&id=bf2f6ec8&scoped=true"
import script from "./releaseDtu.vue?vue&type=script&lang=js"
export * from "./releaseDtu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf2f6ec8",
  null
  
)

export default component.exports